import React, { useState } from "react";
import {
  download,
  generateCsv,
  mkConfig,
} from "export-to-csv";
import {
  Checkbox,
  Button,
  FormControlLabel,
  Dialog,
  DialogContent,
  Stack,
  Box,
} from "@mui/material";
import * as XLSX from "xlsx";
import type {
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "material-react-table";
import {useGetAllReportAgentiVersore} from "./Services";
import {ReportAgentiVersore} from "./types";
import {useGetVersOreDTO} from "../gestversore/Services";

interface ReportAgentiVersoreExpProps {
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  globalFilter: string;
  sorting: MRT_SortingState;
  columnVisibility: Record<string, boolean>;
  columns: MRT_ColumnDef<ReportAgentiVersore>[];
  onClose: () => void;
}

const exportPagination = { pageIndex: 0, pageSize:10000 };

const ReportAgentiVersoreExp: React.FC<ReportAgentiVersoreExpProps> = ({
  pagination,
  columnFilters,
  globalFilter,
  sorting,
  columnVisibility,
  columns,
  onClose,
}) => {
  const { data: { results = [] } = {} } = useGetAllReportAgentiVersore(
    exportPagination,
    columnFilters,
    globalFilter,
    sorting
  );




const fieldDefinitions = columns
      .filter((col) => {
        if (!col.accessorKey) return false; // ignore columns without keys
        // visible if key is missing or true, hidden if explicitly false
        return columnVisibility[col.accessorKey as string] !== false;
      })
      .map((col) => ({
        key: col.accessorKey as keyof ReportAgentiVersore,
        label: typeof col.header === 'string' ? col.header : String(col.accessorKey),
      }));


const [selectedFields, setSelectedFields] = useState<
    (keyof ReportAgentiVersore)[]
  >(fieldDefinitions.map((f) => f.key));

  const handleFieldToggle = (field: keyof ReportAgentiVersore) => {
    setSelectedFields((prevFields) =>
      prevFields.includes(field)
        ? prevFields.filter((item) => item !== field)
        : [...prevFields, field]
    );
  };

const generateExcelData = () => {
  return results.map((item) => {
    const rowData: any = {};

    fieldDefinitions.forEach(({ key, label }) => {
      if (selectedFields.includes(key)) {
        const value = item[key];

        if (value === undefined || value === null || value === "") {
          rowData[label] = null;
        } else if (
          typeof value === "string" &&
          !isNaN(Number(value.replace(",", ".")))
        ) {
          rowData[label] = Number(value.replace(",", "."));
        } else {
          rowData[label] = value;
        }
      }
    });

    return rowData;
  });
};

  const handleExportExcel = () => {
    const excelData = generateExcelData();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ReportAgentiVersOre");
    XLSX.writeFile(workbook, "reportagentiversore.xlsx");
  };

  const csvConfig = mkConfig({
    filename: "ReportAgentiVersore",
    fieldSeparator: ";",
    decimalSeparator: ",",
    useKeysAsHeaders: true,
    showColumnHeaders: true,
  });

  const handleExportCSV = () => {
  if (!results || results.length === 0) return;

  const selectedData = results.map((item) => {
    const rowData: any = {};
    fieldDefinitions.forEach(({ key, label }) => {
      if (selectedFields.includes(key)) {
        rowData[label] = item[key] ??  null;
      }
    });
    return rowData;
  });

  if (!selectedData.length) return;

  const csv = generateCsv(csvConfig)(selectedData);
  download(csvConfig)(csv);
};

  return (
    <Dialog onClose={onClose} open fullWidth maxWidth="md">
     <DialogContent>
            <h4>Seleziona Campi da esportare:</h4>
            <form>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(8, 1fr)', // 8 columns
                  gap: 1,
                }}
              >
                {fieldDefinitions.map(({ key, label }) => (
                  <FormControlLabel
                    key={key}
                    control={
                      <Checkbox
                        checked={selectedFields.includes(key)}
                        onChange={() => handleFieldToggle(key)}
                      />
                    }
                    label={label}
                  />
                ))}
              </Box>
            </form>
          </DialogContent>

      <DialogContent>
        <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
          <Button
            fullWidth
            color="primary"
            variant="outlined"
            onClick={() =>
              setSelectedFields(fieldDefinitions.map((f) => f.key))
            }
          >
            SELEZIONA TUTTI
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="outlined"
            onClick={() => setSelectedFields([])}
          >
            DESELEZ. TUTTI
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={handleExportCSV}
          >
            EXPORT TO CSV
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={handleExportExcel}
          >
            EXPORT TO EXCEL
          </Button>
          <Button fullWidth variant="contained" onClick={onClose} color="error">
            CHIUDI
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ReportAgentiVersoreExp;
